import { useCallback, useState } from 'react';

import { AgGridReact } from 'ag-grid-react';
import { PrimeIcons } from 'primereact/api';
import { Button } from 'primereact/button';

import { useAppSelector } from '@/app/hooks';
import { useGetIssueManagersQuery } from '@/app/services/issues';
import { WithLocalStorage } from '@/components/hoc';
import { useDefaultGridOptions } from '@/grid';
import { defaultColDef } from '@/grid/defaults';
import { RequestIssueManagerFragment, RequestIssueType } from '@/rtk-query.gql';

import { issuesSettingsColDefs } from './columnDefs';
import { CreateIssueManagerInput } from './constants';
import { ManagerModal } from './ManagerModal';

export const IssueSettingsPage = () => {
  const defaultGridOptions = useDefaultGridOptions();
  const { mode } = useAppSelector((state) => state.preferences);

  const [input, setInput] = useState<
    RequestIssueManagerFragment | CreateIssueManagerInput | undefined
  >();

  const handleAddUser = useCallback(() => {
    setInput({ adUserId: null, issueType: null });
  }, []);

  const { data: clientRequestIssueManagersData } = useGetIssueManagersQuery({
    issueType: RequestIssueType.CLIENT,
  });

  return (
    <div className="issues-settings-page common-page">
      <div className="content-panel glass toolbar-above-panel">
        <Button
          onClick={handleAddUser}
          label="Add User"
          severity="secondary"
          icon={PrimeIcons.PLUS}
        />
      </div>
      <WithLocalStorage storageKey="issues-settings__grid">
        <AgGridReact
          gridOptions={defaultGridOptions}
          className={`ag-theme-transova${mode === 'dark' ? '-dark' : ''}`}
          defaultColDef={defaultColDef}
          columnDefs={issuesSettingsColDefs}
          rowData={clientRequestIssueManagersData}
          overlayLoadingTemplate="Loading closed issues..."
          rowSelection="single"
          onRowDoubleClicked={(e) => setInput(e.data)}
        />
      </WithLocalStorage>
      <ManagerModal
        input={input}
        close={() => {
          setInput(undefined);
        }}
        show={setInput}
      />
    </div>
  );
};
